import { ContainerInput } from './styles';
import { Input, InputProps } from 'antd';

export const AInput: React.FC<InputProps> = ({ ...res }) => {
  return (
    <ContainerInput>
      <Input {...res} />
    </ContainerInput>
  );
};
